import PropTypes from 'prop-types';
import React from 'react';


const DEV_HOST = "https://dev.ssr.col.movistar.es"
const PROD_HOST = "https://ssr.col.movistar.es"

function change2Webm(source=''){
  let tokens = source.split('.');
  tokens[tokens.length - 1] = 'webm';
  return tokens.join('.');
}

const getVideoId = (entryPoint = '') => {
  let tmp = entryPoint.split('.');
  tmp = tmp[tmp.length - 1];
  tmp = tmp.split('-');
  return tmp[tmp.length - 1];
};


const makePosterSrc = (enablePoster, currentEnv, poster) => {
  if(!enablePoster || enablePoster === "false"){
    return ""
  };

  if (currentEnv !== 'prod'){
    return `${DEV_HOST}${poster}`
  }

  return `${PROD_HOST}${poster}`
}

const makeAbsSource = (source) => {
  switch(currentEnv) {
    case 'prod':
      return `${PROD_HOST}${source}`
    default: 
     return `${DEV_HOST}${source}`
  }
}

const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`

function Video(props){
  const {
    source,
    className='',
    autoplay=true,
    controls=false,
    muted=true,
    preload=false,
    loop=true,
    enablePoster=true,
    poster="/static/pictures/cms/poster-video.jpg",
    cmsHandler=null,
  } = props;

  if (cmsHandler) {
    return (
      <span
      className={`cms-video cms-video-${getVideoId(source)} element-editable`}
      onClick={cmsHandler ? () => cmsHandler({ ...props, name: 'cms-block.cms-video' }) : null}
      > Video</span>
    )
  }
  
  if (!source) { return null }
   
  const finalPosterSrc = makePosterSrc(enablePoster, currentEnv, poster);
  const mp4Source = makeAbsSource(source)
  const webmSource = change2Webm(mp4Source);

  return (
    <>
      <video 
        className={`cms-video${className ? ` ${className}` : ''}`}
        controls={controls && controls === 'true'} 
        preload={preload && preload === 'true'} 
        muted={muted && muted === 'true'} 
        autoPlay={autoplay && autoplay === 'true'} 
        loop={loop && loop === 'true'} 
        poster={finalPosterSrc}
        playsInline
      > 
          <source src={webmSource} type="video/webm"></source>
          <source src={mp4Source} type="video/mp4"></source>
      </video>
      <style jsx>{`.cms-video {
}
`}</style>
    </>
  )
}

Video.propTypes = {
  /**
   * {
   *  "info": "Cargue su recurso audiovisual en formato .mp4",
   *  "kind": "both",
   *  "beautifulName": "Fichero"
   * }
   */
  source: PropTypes.string,
  /**
   * {
   *  "info": "Deja al usuario interacutar con la reproducción y volumen del video",
   *  "kind": "both",
   *  "beautifulName": "controles"
   * }
   */
  controls: PropTypes.bool,
  /**
   * {
   *  "info": "Solo usar en casos especiales,prioriza la carga del video en aterrizaje de página",
   *  "kind": "both",
   *  "beautifulName": "Muted"
   * }
   */
  preload: PropTypes.bool,
  /**
   * {
   *  "info": "Deje marcada esta opción para reproducir sin audio",
   *  "kind": "both",
   *  "beautifulName": "Muted"
   * }
   */
  muted: PropTypes.bool,
  /**
   * {
   *  "info": "Deje marcada esta opción para reproducir automáticamente",
   *  "kind": "both",
   *  "beautifulName": "Autoplay"
   * }
   */
  autoplay: PropTypes.bool,
  /**
   * {
   *  "info": "Deje marcada esta opción para reproducir en bucle",
   *  "kind": "both",
   *  "beautifulName": "Loop"
   * }
   */
  loop: PropTypes.bool,
  /**
   * {
   *  "info": "Activar o desactivar poster",
   *  "kind": "both",
   *  "beautifulName": "Habilita poster indicado"
   * }
   */
  enablePoster: PropTypes.bool,
  /**
   * {
   *  "info": "Establezca una imagen de durante la carga inicial del video, recomendable colocar primer frame",
   *  "kind": "both",
   *  "beautifulName": "Poster"
   * }
   */
  poster: PropTypes.string,
};


export default Video;